(function (Drupal, $) {
  var tablesProcessed = false; // Flag to check if tables are already processed
  Drupal.behaviors.tables = {
    attach: function (context) {
      if (!tablesProcessed) {
        $(function() {
          // Check if table_wrapper exists
          if ($('.table_wrapper').length === 0) {
            // Table horizontal scroll
            var $table = $("table");
            if ($table.length > 0) {
              var $this = $table.eq(0); // Select the first table
              var wrapper1 = $this.parent();
              wrapper1.wrap('<div class="table_wrapper"></div>')
              wrapper1.before('<div class="scroll-simulator_wrapper"><div class="scroll-simulator"></div></div>');
              var wrapper2 = wrapper1.siblings(".scroll-simulator_wrapper");
              var simulator = wrapper2.children(".scroll-simulator");

              function adjustScroll(source) {
                if (source === "original") {
                  $(wrapper2).scrollLeft($(wrapper1).scrollLeft());
                }
                if (source === "simulated") {
                  $(wrapper1).scrollLeft($(wrapper2).scrollLeft());
                }

                if ($this.width() > wrapper1.width()) {
                  wrapper2.addClass("scrolling");
                } else {
                  wrapper2.removeClass("scrolling");
                }
                adjustBlur();
              }

              function adjustBlur() {
                var $width = wrapper1.outerWidth();
                var $scrollWidth = wrapper1[0].scrollWidth;
                var $scrollLeft = wrapper1.scrollLeft();
                var $offset = 10;

                $scrollWidth - $width < $scrollLeft + $offset
                  ? wrapper1.removeClass("scrollable-right")
                  : wrapper1.addClass("scrollable-right");
                $scrollLeft < $offset
                  ? wrapper1.removeClass("scrollable-left")
                  : wrapper1.addClass("scrollable-left");
              }

              simulator.width($this.width());
              adjustScroll();

              $(window).resize(function () {
                simulator.width($this.width());
                adjustScroll();
              });

              $(wrapper1).scroll(function () {
                adjustScroll("original");
              });
              $(wrapper2).scroll(function () {
                adjustScroll("simulated");
              });

              tablesProcessed = true; // Set the flag to true after processing
            }
          }
        });      
      }
    }
  }
})(Drupal, jQuery);
